import Image from 'next/image'
import React from 'react'
import { ResponsiveImageType } from 'react-datocms'
import styled from 'styled-components'

import { FragmentComponent } from '@/types/graphql'

import { responsiveImageBlock } from '@/graphql/utils/commonBlocks'

export type FullWidthMediaAssetRecord = {
  __typename: 'FullWidthMediaAssetRecord'
  id: string
  image: {
    responsiveImage: ResponsiveImageType
  }
  maxWidth?: number
}

const fragment = `
  fragment FullWidthMediaAssetBlockFragment on FullWidthMediaAssetRecord {
    __typename
    id
    maxWidth
    image {
      ${responsiveImageBlock()}
    }
  }
`
const StyledAssetContainer = styled.div<{ $maxWidth?: number }>`
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : '100%')};
  margin: 0 auto;

  ${({ $maxWidth }) =>
    $maxWidth &&
    ` @media screen and (min-width: ${$maxWidth}px) {
      border-radius: var(--radius-16);
      overflow: hidden;
    }`};
`

export const FullWidthMediaAssetBlock: FragmentComponent<{}, FullWidthMediaAssetRecord> = ({ record }) => {
  return (
    record.image.responsiveImage && (
      <StyledAssetContainer $maxWidth={record.maxWidth}>
        <Image
          src={record?.image?.responsiveImage?.src || ''}
          alt={record?.image?.responsiveImage?.alt || ''}
          sizes={record?.image?.responsiveImage?.sizes || ''}
          width={record?.image?.responsiveImage?.width || 0}
          height={record?.image?.responsiveImage?.height || 0}
          blurDataURL={record?.image?.responsiveImage?.base64 || ''}
        />
      </StyledAssetContainer>
    )
  )
}

FullWidthMediaAssetBlock.fragment = fragment
FullWidthMediaAssetBlock.recordName = 'FullWidthMediaAssetRecord'
